import type { AgentHubBookingOnboardingStatus } from './agentHubBookingOnboardingStorage'

export function canStartAgentHubBookingOnboarding(options: {
  hasOrders: boolean
  haveOrdersBeenFetched: boolean
  isAgentHubEnabled: boolean
  isHomepage: boolean
  isLoggedIn: boolean
  isSpoofed: boolean
  memberId?: string
  storedStatus?: AgentHubBookingOnboardingStatus
}): boolean {
  const {
    hasOrders,
    haveOrdersBeenFetched,
    isAgentHubEnabled,
    isHomepage,
    isLoggedIn,
    isSpoofed,
    memberId,
    storedStatus,
  } = options

  if (!isAgentHubEnabled || !isHomepage || !isLoggedIn || isSpoofed || !memberId) {
    return false
  }

  if (!haveOrdersBeenFetched || hasOrders) {
    return false
  }

  if (storedStatus === 'completed' || storedStatus === 'dismissed') {
    return false
  }

  return true
}

export function shouldFetchOrdersForAgentHubBookingOnboarding(options: {
  haveOrdersBeenFetched: boolean
  isAgentHubEnabled: boolean
  isHomepage: boolean
  isLoggedIn: boolean
  memberId?: string
  storedStatus?: AgentHubBookingOnboardingStatus
}): boolean {
  const {
    haveOrdersBeenFetched,
    isAgentHubEnabled,
    isHomepage,
    isLoggedIn,
    memberId,
    storedStatus,
  } = options

  if (!isAgentHubEnabled || !isHomepage || !isLoggedIn || !memberId) {
    return false
  }

  if (storedStatus === 'completed' || storedStatus === 'dismissed') {
    return false
  }

  return !haveOrdersBeenFetched
}

export function canReplayAgentHubBookingOnboarding(options: {
  isAgentHubEnabled: boolean
  isLoggedIn: boolean
  isSpoofed: boolean
}): boolean {
  const { isAgentHubEnabled, isLoggedIn, isSpoofed } = options

  return isAgentHubEnabled && isLoggedIn && !isSpoofed
}

export function canShowAgentHubEarnYourOwnTourModal(options: {
  hasOrders: boolean
  haveOrdersBeenFetched: boolean
  isAgentHubEnabled: boolean
  isLoggedIn: boolean
  isSpoofed: boolean
  memberId?: string
  storedStatus?: AgentHubBookingOnboardingStatus
}): boolean {
  const {
    hasOrders,
    haveOrdersBeenFetched,
    isAgentHubEnabled,
    isLoggedIn,
    isSpoofed,
    memberId,
    storedStatus,
  } = options

  if (!isAgentHubEnabled || !isLoggedIn || isSpoofed || !memberId) {
    return false
  }

  if (storedStatus === 'completed' || storedStatus === 'dismissed') {
    return true
  }

  if (!haveOrdersBeenFetched) {
    return false
  }

  return hasOrders
}
